import createItemsDuck from '@esentai/core/ducks/items';

import api from '../api';
import { getItemsRoot } from '../utils';

export default createItemsDuck('sales_turnover', {
  api,
  getRoot: getItemsRoot,
});
